import axios from '../config/axiosConfig';

// OAST (Out-of-Band Application Security Testing) via ExposIQ integration
// Uses ExposIQ's Interactsh OAST server (oast.exposiq.ch)

const API_URL = '/exposiq';

const generatePayload = async (type, options = {}) => {
  const response = await axios.post(`${API_URL}/oast/generate`, { type, ...options });
  return response.data;
};

const pollCallbacks = async (token) => {
  const response = await axios.get(`${API_URL}/oast/poll/${token}`);
  return response.data;
};

const getTokens = async (webTargetId) => {
  const response = await axios.get(`${API_URL}/oast/tokens`, { params: { webTargetId } });
  return response.data;
};

const deactivateToken = async (token) => {
  const response = await axios.post(`${API_URL}/oast/deactivate`, { token });
  return response.data;
};

// OAST payload types
const payloadTypes = [
  { key: 'dns', label: 'DNS', description: 'DNS callback - detects blind SSRF, XXE, etc.' },
  { key: 'http', label: 'HTTP', description: 'HTTP callback - detects SSRF, remote includes' },
  { key: 'https', label: 'HTTPS', description: 'HTTPS callback - encrypted OOB channel' },
  { key: 'ldap', label: 'LDAP', description: 'LDAP callback - detects Log4Shell, JNDI injection' },
  { key: 'rmi', label: 'RMI', description: 'RMI callback - detects Java deserialization' },
  { key: 'smb', label: 'SMB', description: 'SMB callback - detects NTLM relay, UNC path injection' },
  { key: 'ftp', label: 'FTP', description: 'FTP callback - detects blind XXE with FTP exfiltration' },
  { key: 'smtp', label: 'SMTP', description: 'SMTP callback - detects email header injection' }
];

const oastService = {
  generatePayload,
  pollCallbacks,
  getTokens,
  deactivateToken,
  payloadTypes
};

export default oastService;
